// src/Components/Drawer/InfoTab/InfoTabMenu.js

import React from 'react';
import { Box, IconButton } from '@mui/material';

import {
  MenuAddNewGrey,
  MenuSave,
  MenuSaveGrey,
  MenuDelete,
  MenuDeleteGrey,
  MenuIconCancel,
  MenuIconCancelGrey,
} from '../../../assets/icons/CustomIcons';

export default function InfoTabMenu({
  handleHeaderAction,
  selectedMarker,
  isEditing,
  isDirty,
  isAppFullScreen,
}) {
  const toolBlockStyle = {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minWidth: 0,
  };

  const ICON_SIZE = 64; // Retained original icon size

  // AMENDED: Strictly check for a real marker (id or isNew) to ignore the empty tempData placeholder
  const isSelected = !!(selectedMarker && (selectedMarker.id || selectedMarker.isNew));

  const disableAdd = true;
  const showControls = isEditing && isSelected;
  const enableSave = showControls && isDirty;

  // AMENDED: Cancel should always be active if controls are showing (to close the drawer) or if in full screen
  const enableCancel = showControls || isAppFullScreen;

  // Squashed the clickable focus area into a sleek rectangle that fits the 45px bar
  const buttonSx = {
    p: 0,
    height: '38px',
    width: '60px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
    // Shifts the oversized SVG up by 8px to reveal the text cut off at the bottom
    '& svg': { transform: 'translateY(-8px)' },
  };

  return (
    <Box
      sx={{
        height: '100%', // Fills the 45px wrapper
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '5px',
        paddingRight: '5px',
      }}>
      <Box sx={toolBlockStyle}>
        <IconButton sx={buttonSx} disabled={disableAdd}>
          <MenuAddNewGrey sx={{ fontSize: ICON_SIZE }} />
        </IconButton>
      </Box>

      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!enableSave}
          onClick={() => handleHeaderAction('SAVE')}>
          {enableSave ? (
            <MenuSave sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuSaveGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>

      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!isSelected}
          onClick={() => handleHeaderAction('DELETE')}>
          {isSelected ? (
            <MenuDelete sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuDeleteGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>

      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!enableCancel}
          onClick={() => handleHeaderAction('CLOSE')}>
          {enableCancel ? (
            <MenuIconCancel sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuIconCancelGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>
    </Box>
  );
}
